(function () {
  var THRESHOLD = 25;

  function initCard(wrapper) {
    var imgs = wrapper.querySelectorAll('.dl-swipe-img');
    if (imgs.length < 2) return;

    var current = 0;
    var startX = 0;
    var dragging = false;
    var wasDrag = false;

    imgs[0].classList.add('dl-active');

    function goTo(n) {
      imgs[current].classList.remove('dl-active');
      current = ((n % imgs.length) + imgs.length) % imgs.length;
      imgs[current].classList.add('dl-active');
    }

    function onStart(x) {
      startX = x;
      dragging = true;
      wasDrag = false;
    }

    function onMove(x) {
      if (!dragging) return;
      if (Math.abs(x - startX) > 8) wasDrag = true;
    }

    function onEnd(x) {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(x - startX) >= THRESHOLD) {
        goTo(x < startX ? current + 1 : current - 1);
      }
    }

    wrapper.addEventListener('touchstart', function (e) { onStart(e.touches[0].clientX); }, { passive: true });
    wrapper.addEventListener('touchmove',  function (e) { onMove(e.touches[0].clientX); },  { passive: true });
    wrapper.addEventListener('touchend',   function (e) { onEnd(e.changedTouches[0].clientX); }, { passive: true });

    wrapper.addEventListener('mousedown',  function (e) { onStart(e.clientX); });
    wrapper.addEventListener('mousemove',  function (e) { if (dragging) onMove(e.clientX); });
    wrapper.addEventListener('mouseup',    function (e) { onEnd(e.clientX); });
    wrapper.addEventListener('mouseleave', function ()  { dragging = false; });

    var cardWrapper = wrapper.closest('.card-wrapper') || wrapper.parentElement;
    cardWrapper.addEventListener('click', function (e) {
      if (wasDrag) {
        e.preventDefault();
        e.stopPropagation();
        wasDrag = false;
      }
    }, true);

    wrapper.dataset.dlSwipeReady = '';
  }

  function initAll() {
    document.querySelectorAll('[data-dl-swipe]:not([data-dl-swipe-ready])').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
